import styled, { css } from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { BuyPremiumIcon } from '@root/entities/premium/ui'
import { useBreakpoint } from '@root/shared'
import { mediaMinTablet } from '@root/shared/ui-kit'

import type { PremiumMeta } from '@root/entities/premium'

type Props = {
  title: React.ReactElement
  subTitle: string
  product: PremiumMeta.PremiumProduct
}

export const PremiumInfoHeader: React.FC<Props> = ({
  title,
  subTitle,
  product,
}) => {
  const breakpoint = useBreakpoint()
  const isMobile = breakpoint === 'mobile'

  return (
    <Root>
      <Heading>
        <BuyPremiumIcon
          product={product}
          size={isMobile ? 48 : 46}
          sizeIcon={isMobile ? 20 : 24}
        />
        <Title $product={product}>{title}</Title>
      </Heading>
      <Subtitle>{subTitle}</Subtitle>
    </Root>
  )
}

const Root = styled.header`
  color: var(--text-12);
  display: grid;

  padding-block: 12px 10px;

  ${mediaMinTablet(css`
    padding-block: 0 16px;
  `)}
`

const Heading = styled.div`
  display: grid;
  ${mediaMinTablet(css`
    grid-template-columns: auto auto;
    place-content: center;
    align-items: center;

    gap: 14px;

    margin-bottom: 16px;
  `)}
`

const Title = styled(Typography).attrs({
  variant: 'body1-bold',
  component: 'h3',
})<{
  $product: PremiumMeta.PremiumProduct
}>`
  margin: 10px 0;

  text-align: center;
  text-transform: uppercase;

  span {
    background: linear-gradient(
      90deg,
      ${({ $product }) =>
          $product === 'subscription'
            ? 'var(--subscriptionGradientFrom-9)'
            : 'var(--boostGradientFrom-9)'}
        50%,
      ${({ $product }) =>
          $product === 'subscription'
            ? 'var(--subscriptionGradientTo-9)'
            : 'var(--boostGradientTo-9)'}
        100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`

const Subtitle = styled(Typography).attrs({
  variant: 'body2-medium',
  component: 'p',
})`
  color: var(--textA-8);
`
